import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postUpdateProductURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
  } from "@chakra-ui/react";

function EditProduct({
    isOpen,
    onClose,
    successCallback,
    productData,
}) {

    const [ name, setName ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ carMake, setCarMake ] = useState(null);
    const [ carType, setCarType ] = useState(null);
    const [ carYear, setCarYear ] = useState(null);
    const [ carPart, setCarPart ] = useState(null);

    const [ invName, setInvName ] = useState(null);
    const [ invDescription, setInvDescription ] = useState(null);
    const [ invCarMake, setInvCarMake ] = useState(null);
    const [ invCarType, setInvCarType ] = useState(null);
    const [ invCarYear, setInvCarYear ] = useState(null);
    const [ invCarPart, setInvCarPart ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postProducts = (e) => {
        e.preventDefault();


        let id;
        if (productData) {
            id = productData.id;
        } 

        setSubmitting(true);
        setErrors([]);
        // console.log(stock, price);
        axios.post(postUpdateProductURL(id), {
            // stock,
            // price,
            name,
            description,
            carMake: carMake ?? undefined,
            carType: carType ?? undefined,
            carYear: carYear ?? undefined,
            carPart: carPart ?? undefined
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(name)) {
            setInvName(name.length < 1);
        }

        if (!validator.isEmpty(description)) {
            setInvDescription(description.length < 1);
        }


        if (carMake != null && !validator.isEmpty(carMake)) {
            setInvCarMake(carMake.length < 1);
        }

        if (carType != null && !validator.isEmpty(carType)) {
            setInvCarType(carType.length < 1);
        }

        if (carYear != null && !validator.isEmpty(carYear)) {
            setInvCarYear(carYear.length < 1);
        }

        if (carPart != null && !validator.isEmpty(carPart)) {
            setInvCarPart(carPart.length < 1);
        }

    }, [name,  description,  carMake, carType, carYear, carPart]);



    useEffect(() => {

        if (productData) {
            // console.log(productData);
            setName(productData.name);
            setDescription(productData.description);
            setCarMake(productData.carMake);
            setCarType(productData.carType);
            setCarYear(productData.carYear);
            setCarPart(productData.carPart);
        }

    }, [productData]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Edit {productData ? productData.name : ''}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postProducts}>
                    <FormControl >
                        
                    <Box pr="12px">
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Product Name
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Product Name"
                            size="md" 
                            isInvalid={invName === true}
                            isRequired={true}
                            value={name} 
                            onChange={e => setName(e.target.value)}
                        />
                    </Box>

                    <Box pr="12px">
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Description
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Product Description"
                            size="md" 
                            isInvalid={invDescription === true}
                            isRequired={true}
                            value={description} 
                            onChange={e => setDescription(e.target.value)}
                        />
                    </Box>
                    
                    <Text fontSize="sm" color="gray.400" fontWeight="bold" marginTop={4}>
                        FOR SPECIFIC VEHICLE (Optional)
                    </Text>


                    <Flex w="100%"
                        flexDirection={{
                        sm: "row",
                        md: "row",
                        }} 
                        alignItems={{ xl: "center" }}>

                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Car Make
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Toyota"
                                size="md" 
                                isInvalid={invCarMake === true}
                                isRequired={false}
                                value={carMake} 
                                onChange={e => setCarMake(e.target.value)}
                            />
                        </Box>

                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Car Type
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Camry"
                                size="md" 
                                isInvalid={invCarType === true}
                                isRequired={false}
                                value={carType} 
                                onChange={e => setCarType(e.target.value)}
                            />
                        </Box>
                    
                    </Flex>
                    
                    <Flex w="100%"
                        flexDirection={{
                        sm: "row",
                        md: "row",
                        }} 
                        alignItems={{ xl: "center" }}>

                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Car Year
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="2000"
                                size="md" 
                                isInvalid={invCarYear === true}
                                isRequired={false}
                                value={carYear} 
                                onChange={e => setCarYear(e.target.value)}
                            />
                        </Box>

                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Car Part No
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Car Part No"
                                size="md" 
                                isInvalid={invCarPart === true}
                                isRequired={false}
                                value={carPart} 
                                onChange={e => setCarPart(e.target.value)}
                            />
                        </Box>

                    </Flex>


                    <Flex w="100%" flexDir="column">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>
                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={submitting}
                    >
                        SUBMIT
                    </Button>
                </FormControl>
            </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default EditProduct;
